<template>
  <div
      :class="{ 'is-compact': compact }"
      class="lp-field-group">
    <div
        v-if="label || hint || $slots.aside"
        class="lp-field-group__label">
      <span>{{ label }}</span>
      <slot name="aside">
        <span
            v-if="hint"
            class="lp-field-group__hint">{{ hint }}</span>
      </slot>
    </div>
    <slot/>
  </div>
</template>

<script>
export default {
  name:  'FieldGroup',
  props: {
    label:   { type: String, default: '' },
    hint:    { type: String, default: '' },
    compact: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-field-group {
  margin-top: 16px;

  &.is-compact {
    margin-top: 8px;
  }
}

.lp-field-group__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-family: $lp-sans;
  font-size: $lp-fs-label;
  font-weight: 600;
  line-height: 16px;
  color: $lp-muted;
}

.lp-field-group__hint {
  font-weight: 500;
  color: $lp-muted;
}
</style>
